import { render } from "./QuestionnairePage.vue?vue&type=template&id=7d4a7712&lang=html"
import script from "./QuestionnairePage.vue?vue&type=script&lang=js"
export * from "./QuestionnairePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__